/**
 * StaffDashboardPage - Staff operations dashboard
 *
 * Wrapper page for the StaffDashboard component that provides
 * frontline work management, task completion, and personal metrics.
 *
 * Route: /dashboards/staff
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';

import { StaffDashboard } from './StaffDashboard';
import { useAuth } from '@/auth/AuthContext';

export function StaffDashboardPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="grape">
            <IconUser size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Staff Dashboard</Title>
            <Text size="sm" c="dimmed">
              Personal task management, work completion, and performance metrics
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <StaffDashboard />
    </Container>
  );
}

export default StaffDashboardPage;
